import axios from "axios";
import {SERVER_URL} from "../config";
import {authHeader} from "_helpers";

function getCustomField(customFieldId) {
    const endpoint = `${SERVER_URL}/api/v1/custom-fields/${customFieldId}`;
    return axios.get(endpoint,{
        headers: authHeader()
    })
}

function updateCustomField(id, payload) {
    const endpoint = `${SERVER_URL}/api/v1/custom-fields/${id}`;
    return axios.put(endpoint, payload, {
        headers: authHeader()
    })
}

function deleteCustomField(id) {
    const endpoint = `${SERVER_URL}/api/v1/custom-fields/${id}`;
    return axios.delete(endpoint, {
        headers: authHeader()
    })
}

function createCustomField(payload) {
    const endpoint = `${SERVER_URL}/api/v1/custom-fields/create`;
    return axios.post(endpoint, payload, {
        headers: authHeader()
    })
}

function listCustomFields(msgDataSourceId) {
    const endpoint = `${SERVER_URL}/api/v1/custom-fields/list`;
    return axios.get(endpoint,{
        params: {msgDataSourceId},
        headers: authHeader()
    })
}

function fetchCustomFields(msgDataSourceId) {
    const endpoint = `${SERVER_URL}/api/v1/custom-fields/fetch`;
    return axios.get(endpoint,{
        params: {msgDataSourceId},
        headers: authHeader()
    })
}

export const customFieldService = {
    getCustomField,
    updateCustomField,
    deleteCustomField,
    createCustomField,
    listCustomFields,
    fetchCustomFields
};